import Vue from 'vue';
import apiClient from '../../apiClient';
import { dateToLocal } from '@/modules/dates';
import config from '@/config';

const state = {
  stats: {
    wait: 0,
    contract: 0,
    production: 0
  },
  orders: [],
  clientOrders: [],
  currentOrder: {
    id: '',
    number: '',
    client_id: '',
    firm_id: '',
    constructor_id: '',
    image_path: '',
    model: '',
    amount: 0,
    profit: 0,
    status: '',
    created_at: '',
    updated_at: '',
    contract_number: '',
    completed_at: '',
    assembly_at: '',
    comments: '',
    client: {
      id: '',
      name: '',
      address: '',
      contact_phone: '',
      contact_email: '',
      created_at: '',
      updated_at: ''
    },
    constructor: {
      id: '',
      name: '',
      created_at: '',
      updated_at: ''
    }
  }
};

const actions = {
  orderGet: ({ commit }, orderId) =>
    new Promise((resolve, reject) => {
      apiClient
        .get(`/orders/${orderId}`)
        .then(response => {
          commit('order', response.data.order);

          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    }),

  orderUpdate: ({ dispatch }, { orderId, payload }) =>
    new Promise((resolve, reject) => {
      apiClient
        .put(`/orders/${orderId}`, payload)
        .then(response => {
          dispatch('orderGet', orderId);

          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    }),

  orderDelete: (_context, orderId) =>
    new Promise((resolve, reject) => {
      apiClient
        .delete(`/orders/${orderId}`)
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    }),

  ordersGet: ({ commit }, firmId) =>
    new Promise((resolve, reject) => {
      apiClient
        .get(`/firms/${firmId}/orders`)
        .then(response => {
          const { orders, stats } = response.data;

          // Dates to local timezone
          orders.forEach(item => {
            const dateFields = (({
              assembly_at,
              created_at,
              completed_at
            }) => ({
              assembly_at,
              created_at,
              completed_at
            }))(item);
            for (const [key, value] of Object.entries(dateFields)) {
              item[key] = dateToLocal(
                value,
                config.dateTimeInputFormat,
                config.dateTimeInputFormat
              );
            }
          });

          // Commit to store
          commit('ordersList', orders);
          commit('ordersStats', stats);

          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    }),

  clientOrders: ({ commit }, clientId) =>
    new Promise((resolve, reject) => {
      apiClient
        .get(`/clients/${clientId}/orders`)
        .then(response => {
          commit('clientOrders', response.data);
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    })
};

const mutations = {
  order: (state, order) => {
    Vue.set(state, 'currentOrder', order);
  },
  ordersList: (state, orders) => {
    Vue.set(state, 'orders', orders);
  },
  clientOrders: (state, clientOrders) => {
    Vue.set(state, 'clientOrders', clientOrders);
  },
  assemblyOrdersList: (state, orders) => {
    Vue.set(state, 'assmblyOrders', orders);
  },
  ordersStats: (state, stats) => {
    Vue.set(state, 'stats', stats);
  }
};

export default {
  state,
  actions,
  mutations
};
